/**
 * @generated SignedSource<<177cf19296b3482f58658857f4a679aa>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SwatchSelectorMinimal_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useSwatches_item">;
  readonly " $fragmentType": "SwatchSelectorMinimal_item";
};
export type SwatchSelectorMinimal_item$key = {
  readonly " $data"?: SwatchSelectorMinimal_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"SwatchSelectorMinimal_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SwatchSelectorMinimal_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSwatches_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "048096acaa92191d88df59bfbf49a7ac";

export default node;
